import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Cart } from '@spartacus/core';
import { Observable } from 'rxjs';
import { CartActions } from '../store/actions';
import { StateWithCustomCart } from '../store/cart-state';
import { CloneCartSelectors } from '../store/selectors';

@Injectable({
  providedIn: 'root',
})
export class CloneCartFacade {
  constructor(protected store: Store<StateWithCustomCart>) {}

  getClonedCartValue(): Observable<Cart> {
    return this.store.pipe(select(CloneCartSelectors.getCloneCartValue));
  }

  resetClonedCartValue(): void {
    this.store.dispatch(new CartActions.CloneCartReset());
  }
}
